<div [ngBusy]="{busy: fetchSubscription, message: 'Loading PL/Snapshot List ...'}"></div>
<div class="card" style="height: 100%">
  <div class="card-header text-white card-custom">
    <h3>Available Reports</h3>
    <p>To filter the list, click on the column header and enter the appropriate value.</p>
  </div>
  <ag-grid-angular
      style="width: 100%;height: 100%"
      class="ag-theme-alpine"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColumDefs"
      (gridReady)="onGridReady($event)"
      [frameworkComponents]="frameworkComponents"
      [modules]="modules">
  </ag-grid-angular>
</div>
